export const DICTIONARY = {
	farmacia: 'Retiro en farmacia',
	domicilio: 'Envío a domicilio',
};
